export const DEFAULT_POSITION_TOOLBARS = -26;
// useBoundingClientRect is used for when the element
// has a relatively positioned parent that we need to calculate the
// boundaries off of.
const makeGetScrollPositionForToolbar = useBoundingClientRect => {
  let lastCachedKey = '';
  let lastResult = null;
  const OFFSET = 25;
  const constrainValue = (top, containerHeight) => {
    return Math.min(top, containerHeight - OFFSET);
  };
  return (scrollContainerBoundaries, containerRef) => {
    let top = `${DEFAULT_POSITION_TOOLBARS}px`;
    if (!containerRef || !scrollContainerBoundaries) {
      return lastResult || top;
    }
    const cacheKey = JSON.stringify({
      scrollContainerBoundaries,
      id: containerRef.id,
      height: containerRef.offsetHeight
    });
    if (cacheKey === lastCachedKey) {
      return lastResult || top;
    }
    lastCachedKey = cacheKey;
    if (scrollContainerBoundaries) {
      let containerTop;
      let containerHeight;
      if (useBoundingClientRect) {
        // element ref is in a relatively positioned element - need to calculate
        const boundaries = containerRef.getBoundingClientRect();
        containerTop = boundaries.top;
        containerHeight = boundaries.height;
      } else {
        const parentBoundaries = {
          top: containerRef.offsetTop,
          height: containerRef.offsetHeight
        };
        if (!scrollContainerBoundaries || !parentBoundaries) {
          lastResult = top;
          return top;
        }
        const {
          scrollTop
        } = scrollContainerBoundaries;
        const {
          top: offsetContainerTop,
          height
        } = parentBoundaries;
        containerHeight = height;
        containerTop = offsetContainerTop - scrollTop;
      }
      if (containerTop > Math.abs(DEFAULT_POSITION_TOOLBARS)) {
        lastResult = top;
        return top;
      }
      const topOffset = containerTop * -1;
      const topValue = constrainValue(topOffset, containerHeight);
      top = `${topValue}px`;
    }
    lastResult = top;
    return top;
  };
};
export const getScrollPositionForElementToolbar = makeGetScrollPositionForToolbar(true);
export const getScrollPositionForSectionToolbar = makeGetScrollPositionForToolbar(true);

// this calculates the position of the handles so that they are always 50% between the boundaries of the visible part of the section
export const getScrollPositionForHandles = (() => {
  let lastCachedKey = '';
  let lastResult = '50%';
  const OFFSET = 25;
  const constrainValue = (top, containerHeight) => {
    return Math.min(Math.max(top, OFFSET), containerHeight - OFFSET);
  };
  return (scrollContainerBoundaries, containerRef) => {
    const cacheKey = JSON.stringify({
      scrollContainerBoundaries,
      id: containerRef.id,
      height: containerRef.offsetHeight
    });
    if (cacheKey === lastCachedKey) return lastResult;
    lastCachedKey = cacheKey;
    let top = '50%';
    if (scrollContainerBoundaries) {
      const {
        top: containerTop,
        height: containerHeight,
        bottom: containerBottom
      } = containerRef.getBoundingClientRect();
      const {
        bottom: layoutContainerBottom,
        top: layoutContainerTop
      } = scrollContainerBoundaries;

      // container is not visible or is fully visible, skip and return 50%
      if (containerTop >= layoutContainerBottom || containerBottom <= layoutContainerTop || containerBottom <= layoutContainerBottom && containerTop >= layoutContainerTop) {
        lastResult = top;
        return top;
      }
      let topValue = 0;

      // bottom of container is not visible
      if (containerBottom >= layoutContainerBottom) {
        // and top of container is not visible
        if (containerTop > 0) {
          const amountVisible = layoutContainerBottom - containerTop;
          topValue = amountVisible / 2;
        } else {
          const halfScrollContainerHeight = layoutContainerBottom / 2;
          const topOffset = containerTop * -1;
          topValue = topOffset + halfScrollContainerHeight;
        }
        // top of container is not visible
      } else if (containerTop <= 0) {
        const topOffset = containerTop * -1;
        const halfVisible = containerBottom / 2;
        topValue = topOffset + halfVisible;
      }
      topValue = constrainValue(topValue, containerHeight);
      top = `${topValue}px`;
    }
    lastResult = top;
    return top;
  };
})();
export const SCROLL_CONTAINER_ID = 'cos_layout_area';
export const getScrollContainer = (isCustom = false) => isCustom ? document.documentElement : document.getElementById(SCROLL_CONTAINER_ID);